<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="总资产" name="totalAssets">
                <a-input v-model:value="searchForm.totalAssets" placeholder="请输入总资产"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            :scroll="{ x: 'calc(1200px + 50%)' }" 
            @change="onTableChange">
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin} from "@/mixins";
import {financeCompanyInfo} from "@/api/finance";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "财政年月", dataIndex: "yearMonth", key: "yearMonth"},
    {title: "总资产(万元)", dataIndex: "totalAssets", key: "totalAssets"},
    {title: "净资产", dataIndex: "retainedAssets", key: "retainedAssets"},
    {title: "固定资产", dataIndex: "fixedAssets", key: "fixedAssets"},
    {title: "流动资产", dataIndex: "liquidAssets", key: "liquidAssets"},
    {title: "资产负债率", dataIndex: "assetsLiabilityRatio", key: "assetsLiabilityRatio"},
    {title: "主营业务收入", dataIndex: "mainBusinessIncome", key: "mainBusinessIncome"},
    {title: "总负债(万元)", dataIndex: "totalLiability", key: "totalLiability"},
    {title: "操作", fixed:'right', dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "信息补充",
    mixins: [tableListMixin],
    components: {
        AddOrEditModal
    },
    data() {
        return {
            dictNames: 'isPublic,serviceStatus,condition,demand_type',
            columns,
            queryParam: {},
            listUrl: financeCompanyInfo.pageList,
            listKeyField: "id",
            deleteUrl: financeCompanyInfo.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeCompanyInfo.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
